export default __webpack_public_path__ + "static/media/098-wolf.9d0d6550.svg";